import React from 'react';
import NiceModal, {useModal} from "@ebay/nice-modal-react";
import AttestorForm, {AttestorFormProps} from "../../../pages/consumers/consumers/components/Attestor/AttestorForm";
import {modalClose} from "../genericFunctions";
import SlideOver, {SlideOverProps} from "../../generic/SlideOver";


interface OwnProps extends SlideOverProps, AttestorFormProps {
}

type Props = OwnProps;

// @ts-ignore
const AttestorModal = NiceModal.create<Props>(({attestor, callback, onClose, header}) => {
    const modal = useModal()

    const handleClose = (e) => {
        modalClose(e, modal, onClose)
    }

    return (
        <SlideOver onClose={handleClose} open={modal.visible} afterClose={modal.remove} title={header}>
            <AttestorForm attestor={attestor} callback={callback}/>
        </SlideOver>
    )
})

export default AttestorModal;
